import React from 'react';
import { Button, Result } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useRouter } from 'next/router';
import { PageDashboard } from '../../consts/routes';
import { RG_ROUTES } from 'src/consts/rgRoutes';
import { isGroupUserSelector } from 'src/selector/app';
import { useSelector } from 'react-redux';

const PageNotFound = () => {
  const router = useRouter();
  const isGroup = useSelector(isGroupUserSelector);

  const goHome = () => {
    if (isGroup) {
      router.replace(RG_ROUTES.report_earnings);
    } else {
      router.replace(PageDashboard);
    }
  };

  return (
    <Result
      status="404"
      title="404"
      subTitle={<FormattedMessage id="page404.subtitle" />}
      extra={
        <Button type="primary" onClick={goHome}>
          <FormattedMessage id="action.backHome" />
        </Button>
      }
    />
  );
};

export default PageNotFound;
